const MODULE_ACTION_TYPES = {
  LOAD_MODULES: 'module/LOAD_MODULES',
};

export default MODULE_ACTION_TYPES;
